import { Injectable } from '@angular/core';
import { PublicTypeModel } from 'src/app/core/models/public-type.model';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/core/base/base.service';
import { AuthService } from '../../../../core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class PublicTypeService extends BaseService<PublicTypeModel> {
  defaultSort = 'createdAt';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'public-type', authService);
  }
}
